import {createAsyncThunk} from "@reduxjs/toolkit";
import axios from "axios";
import {accountUserActions} from "app/accountLoginSlice";
import {USER_LOCALSTORAGE_KEY} from "shared/const/localstorage";
import {createRequestParams} from "common/hook/create-request-params/createRequestParams";
import {setTakeTests} from "features/model/slice/test/test-student/test-take/testTakeSlice";
import {TestTakeResponse} from "features/model/types/test/test-student/test-take/testTakeShema";
import {clearTestState} from "features/model/slice/test/get-test/getTestSlice";
import {resetCorrectTestCount} from "features/model/slice/test/correct-test/correctTestSlice";

interface getTestTakeParams {
    from?: string;
    to?: string;
    page?: number;
}

export const getTestTake = createAsyncThunk(
    "test/getTestTake",
    async ({from, to, page}: getTestTakeParams, thunkAPI) => {
        try {
            thunkAPI.dispatch(clearTestState());
            const authToken = localStorage.getItem(USER_LOCALSTORAGE_KEY);
            if (!authToken) {
                throw new Error("No token found in localStorage.");
            }
            const {token} = JSON.parse(authToken);

            const params = createRequestParams(from, to, page);

            const response = await axios.get<TestTakeResponse>("/api/tests/take", {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
                params,
            });

            if (response.data.success) {
                thunkAPI.dispatch(setTakeTests(response.data));
            }
            if (!response.data.success) {
                throw new Error("Response data is empty");
            }
            return response.data;
        } catch (error) {
            // @ts-ignore
            return thunkAPI.rejectWithValue(error.message);
        }
    }
);